import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { tabletBreakpoints } from '@context/constants';

import { Verse } from '../../../verseTheme';

export const StyledContentBlock = styled.div`
  width: 100%;
  border-style: solid;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  min-height: calc(100vh - 160px);
  border-bottom: 0px;
  border-right: 0px;
  border-left: 0px;
  border-radius: 0px;
  border-color: ${colors.black};

  ${media.sm`
        min-height: unset;
        margin-bottom: 50px;
        border-radius: 24px;
    `}
  @media (min-width: ${tabletBreakpoints.medium}) {
    width: 600px;
    margin: 0 auto;
    margin-bottom: 50px;
    border: 1px solid var(--color-600, ${colors.verseNavBlue});
    box-shadow: ${Verse.glowLight};
    background-color: ${colors.verseDarkViolet};
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  padding: 50px;
`;
